module.exports = "/images/pin-arch-active.png?588ea9f10a094c245dce1e388479cccf";